import React from 'react';
import { PongSpinner } from '../../components/animation/pong-spinner';
import styles from './styles.module.css';

const Waiting = () => {
  return (
    <div className={styles.loadingIndicator}>
      <PongSpinner size={300} color={'#6200ee'} />
    </div>
  );
};

Waiting.propTypes = {};

export default Waiting;
